<div class="page-tree container-fluid">
    <div class="row">
        <nav id="sidebar">
            <ul class="list-unstyled components">
                <li>
                    <a href="#" routerLink="feature">Add Feature</a>
                </li>
                <li>
                    <a href="#" routerLink="subFeature">Add Sub Feature</a>
                </li>
                <li>

                </li>

            </ul>
        </nav>
    </div>
</div>